//import ApiService from                          './api.service';

import ApiServiceAuth from                      './api.service.auth';
import ApiServiceAccount from                   './api.service.account';

import ApiServicePersonalPanels from            './api.service.personal.panels';
import ApiServicePersonalItems from             './api.service.personal.items';

import ApiServicePersonalAccessConnect from     './api.service.personal.access.connect';
import ApiServicePersonalAccessStatus from      './api.service.personal.access.status';
import ApiServicePersonalAccessConfig from      './api.service.personal.access.config';
import ApiServicePersonalAccessInfo from        './api.service.personal.access.info';
import ApiServicePersonalAccessActions from     './api.service.personal.access.actions';

import ApiServiceInstallAccess from     './api.service.install.access';


export default angular.module('app.main.apiTest.services.module', [])
	//.service('ApiService', ApiService)

	.service('ApiServiceAuth', ApiServiceAuth)
	.service('ApiServiceAccount', ApiServiceAccount)

	.service('ApiServicePersonalPanels', ApiServicePersonalPanels)
	.service('ApiServicePersonalItems', ApiServicePersonalItems)

	.service('ApiServicePersonalAccessConnect', ApiServicePersonalAccessConnect)
	.service('ApiServicePersonalAccessStatus', ApiServicePersonalAccessStatus)
	.service('ApiServicePersonalAccessConfig', ApiServicePersonalAccessConfig)
	.service('ApiServicePersonalAccessInfo', ApiServicePersonalAccessInfo)
	.service('ApiServicePersonalAccessActions', ApiServicePersonalAccessActions)

	.service('ApiServiceInstallAccess', ApiServiceInstallAccess)

	.service('ApiServices', [

		'ApiServiceAuth',
		'ApiServiceAccount',

		'ApiServicePersonalPanels',
		'ApiServicePersonalItems',

		'ApiServicePersonalAccessConnect',
		'ApiServicePersonalAccessStatus',
		'ApiServicePersonalAccessConfig',
		'ApiServicePersonalAccessInfo',
		'ApiServicePersonalAccessActions',

		'ApiServiceInstallAccess',


		function(ApiServiceAuth,
		         ApiServiceAccount,
		         ApiServicePersonalPanels,
		         ApiServicePersonalItems,
		         ApiServicePersonalAccessConnect,
		         ApiServicePersonalAccessStatus,
		         ApiServicePersonalAccessConfig,
		         ApiServicePersonalAccessInfo,
		         ApiServicePersonalAccessActions,
		         ApiServiceInstallAccess){
			return {
				list: {
					auth: ApiServiceAuth.service,
					account: ApiServiceAccount.service,

					personalPanels: ApiServicePersonalPanels.service,
					personalItems: ApiServicePersonalItems.service,

					personalAccessConnect: ApiServicePersonalAccessConnect.service,
					personalAccessStatus: ApiServicePersonalAccessStatus.service,
					personalAccessConfig: ApiServicePersonalAccessConfig.service,
					personalAccessInfo: ApiServicePersonalAccessInfo.service,
					personalAccessActions: ApiServicePersonalAccessActions.service,

					installAccess: ApiServiceInstallAccess.service
				}
			}
		}]).name;


/*auth: ApiServiceAuth.service,
 user: ApiServiceUser.service,
 account: ApiServiceAccount.service,
 connect: ApiServiceConnect.service,
 config: ApiServiceConfig.service,
 status: ApiServiceStatus.service,
 actions: ApiServiceActions.service,
 info: ApiServiceInfo.service,
 mobile: ApiServiceMobile.service,
 pictures: ApiServicePictures.service*/


/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/index.js
 **/